export const _billingBillboxOrigin = 'billing.mailbox';
export const _billingDownloadOrigin = 'billing.files';
export const _billingBilldataOrigin = 'billing.thirdpartyrelations';
export const _billingRfcOrigin = 'billing.searchrfc';
export const _billingForeignRfcOrigin = 'billing.searchforeignrfc';
export const _billingRebillOrigin = 'billing.rebill';
